/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { StkIssSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const stkIssSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const stkIssSync01FetchStkIssSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const stkIssSync01FetchStkIssSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const stkIssSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const stkIssSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const stkIssSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const stkIssSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const stkIssSync01SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [StkIssSync01Types.STK_ISS_SYNC01_RESET_TIMESTAMP]: stkIssSync01ResetTimestamp,
  [StkIssSync01Types.STK_ISS_SYNC01_FETCH_STK_ISS_SYNC01_LOADING]: stkIssSync01FetchStkIssSync01Loading,
  [StkIssSync01Types.STK_ISS_SYNC01_FETCH_STK_ISS_SYNC01_SUCCESS]: stkIssSync01FetchStkIssSync01Success,
  [StkIssSync01Types.STK_ISS_SYNC01_ADD_SELECTED_DOCUMENTS]: stkIssSync01AddSelectedDocuments,
  [StkIssSync01Types.STK_ISS_SYNC01_REMOVE_SELECTED_DOCUMENTS]: stkIssSync01RemoveSelectedDocuments,
  [StkIssSync01Types.STK_ISS_SYNC01_SET_WORKSPACE_VISIBLE]: stkIssSync01SetWorkspaceVisible,
  [StkIssSync01Types.STK_ISS_SYNC01_SYNC_LOADING]: stkIssSync01SyncLoading,
  [StkIssSync01Types.STK_ISS_SYNC01_SYNC_NOW_SUCCESS]: stkIssSync01SyncNowSuccess
});
